var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"not-found"},[_c('h2',{staticClass:"title"},[_vm._v("Page doesn't exist")]),_c('div',{},[_vm._v(" Go back to main page "),_c('a',{staticClass:"home-page-link",attrs:{"href":"/"}},[_vm._v("Home")])])])])
}]

export { render, staticRenderFns }